import styled from '@emotion/styled';

export const Container = styled.div(({ width }: { width?: string }) => ({
  display: 'flex',
  flexDirection: 'column' as 'column',
  width: width,
  margin: 5,
}));
